import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { paths } from './paths';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import useUser from 'hooks/useUser';
import { UserRole } from '../types/auth.types';

const hasAnnotatorAccess = (role?: UserRole) =>
  role === UserRole.Annotator || role === UserRole.SuperAdmin;

const hasBinGuidelinesAccess = (role?: UserRole) =>
  hasAnnotatorAccess(role) || role === UserRole.OrgAdmin;

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (
    location.pathname === paths.home &&
    (user?.role === UserRole.Annotator || user?.role === UserRole.SuperAdmin)
  ) {
    return <Navigate to={paths.reviews} replace />;
  }

  if (location.pathname === paths.home && user?.role === UserRole.OrgAdmin) {
    return <Navigate to={paths.adminBinGuidelines} replace />;
  }

  const annotatorOnlyPaths = [
    paths.reviews,
    paths.appVersions,
    paths.adminMaterials,
  ];
  if (annotatorOnlyPaths.includes(location.pathname) && !hasAnnotatorAccess(user?.role)) {
    return <Navigate to={paths.recycle} replace />;
  }

  if (location.pathname === paths.adminOrgAdmins && user?.role !== UserRole.SuperAdmin) {
    return <Navigate to={paths.recycle} replace />;
  }

  if (location.pathname === paths.adminAnnotatorAccess && user?.role !== UserRole.SuperAdmin) {
    return <Navigate to={paths.recycle} replace />;
  }

  if (location.pathname === paths.adminBinGuidelines && !hasBinGuidelinesAccess(user?.role)) {
    return <Navigate to={paths.recycle} replace />;
  }

  return user ? <Outlet /> : <Navigate to={paths.login} replace />;
};

export default ProtectedRoute;
